module.exports = __webpack_public_path__ + "img/small-arrow-down.31817d67.svg";